import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ImgIcon, Spinner } from "../../../assets";
import { remove, save } from "../../../assets/icons";
import { useState } from "react";
import PriceField from "../PriceField";
import { useEffect } from "react";
import AddOnEditor from "./AddOnEditor";
import { createShopAddOn, deleteShopAddOn, updateShopAddOn } from "../../../actions/shop";
import ProductList from "../../ProductList";
import InputWithSuggestions from "../../InputWithSuggestions";
import { useMemo } from "react";

const defaultAddOn = {
	price: 0
}

export default function AddOnManager() {

	const dispatch = useDispatch();
	const { addOns, creating } = useSelector(state => ({ addOns: state.shop.addOns, creating: state.shop.creating }));
	const [newAddOn, setNewAddOn] = useState(defaultAddOn);
	const [search, setSearch] = useState("");
	const lowerCaseSearch = search.toLowerCase();

	const filteredAddOns = addOns
		.filter(addOn => addOn.name.toLowerCase().includes(lowerCaseSearch))
		.sort((a, b) => b.id - a.id)
		.map(addOn => ({ ...addOn, category: addOn.category || "Assorted" }));

	const addOnCategories = useMemo(() => [...new Set(addOns.map(addOn => addOn.category || "Assorted"))], [addOns]);

	return <div className="addOnManager">
		<h4>Create an add-on</h4>
		<section className="addOn-creator">
			<div className="inner">
				Use this tool to create new add-ons.
				<br /><br />
			</div>
			<div className="inner">
				<AddOnEditor
					categories={addOnCategories}
					values={newAddOn}
					onChange={changes => setNewAddOn({
						...newAddOn,
						...changes
					})}
				/>
				<button
					className="fullwidth"
					disabled={creating || !newAddOn.name}
					onClick={e => {
						if (creating || !newAddOn.name) return;
						dispatch(createShopAddOn({ ...newAddOn }, () => {
							setNewAddOn({ ...defaultAddOn, price: newAddOn.price });
						}));
					}}
				>{creating ? <Spinner /> : "Create add-on"}</button>
			</div>
		</section>

		<section>
			<h4>Manage add-ons</h4>
			<div className="inner">
				Search and edit existing add-ons here.
				<br /><br />
				Click a property to start modifying it. Make sure you hit the red save button if you make any changes.
				<br /><br />
			</div>
			<div className="inner search">
				<input
					placeholder="Search add-ons.."
					type="text"
					value={search}
					onChange={e => setSearch(e.target.value)}
				/>
			</div>
		</section>

		<section>
			<ProductList
				branded={false}
				products={filteredAddOns}
				renderProduct={addOn => <AddOnItem
					categories={addOnCategories}
					addOn={addOn}
					key={addOn.id || "new"}
				/>}
			/>
		</section>
	</div>
}

function AddOnItem({ addOn, categories = [] }) {

	const dispatch = useDispatch();
	const [changes, setChanges] = useState({});
	const values = {
		...addOn,
		...changes
	}

	useEffect(() => {
		setChanges({});
	}, [addOn]);

	return <div className="addOn-item" key={values.id || "new"}>
		<div className="flexy featureFont v-middle">
			<div className="name" style={{ flex: 3 }}>
				{/* {values.name} */}
				<input
					className="chameleon"
					type="text"
					value={values.name}
					onChange={e => setChanges({ ...changes, name: e.target.value })}
					onFocus={e => e.target.select()}
				/>
			</div>
			<div className="price" style={{ flex: 2 }}>
				{/* £{(values.price / 100).toFixed(2)} */}
				<PriceField
					value={values.price}
					onChange={price => setChanges({ ...changes, price })}
					tooltipTop={35}
				/>
			</div>
		</div>
		<div className="flexy">
			<div className="description" style={{ flex: 3 }}>
				<textarea
					placeholder="Description.."
					className="chameleon"
					value={values.description || ""}
					onChange={e => setChanges({ ...changes, description: e.target.value })}
				/>
			</div>
			<div className="category-editor" style={{ flex: 2 }}>
				<InputWithSuggestions
					suggestions={categories}
					value={values.category}
					onChange={category => setChanges({ ...changes, category })}
				/>
			</div>
		</div>
		<div className="controls" style={{ flex: 1 }}>
			<ImgIcon
				title="Delete this add-on."
				src={remove}
				size={30}
				iconSize={"65%"}
				bg="#f7f7f7"
				onClick={e => {
					e.stopPropagation();
					if (window.confirm("Are you sure you want to remove this add-on?"))
						dispatch(deleteShopAddOn(addOn.id));
				}}
			/>
			{Boolean(Object.keys(changes).length) && <ImgIcon
				className="brand-bg"
				title="Save changes."
				src={save}
				size={30}
				iconSize={"65%"}
				onClick={e => {
					e.stopPropagation();
					dispatch(updateShopAddOn(addOn.id, { ...changes }));
				}}
			/>}
		</div>
	</div>
}